<ngx-avatars
    [size]="size"
    [src]="null"
    [name]="name"
    [textSizeRatio]="textSizeRatio"
    [bgColor]="'#223540'"
>
</ngx-avatars>
